<template>
  <div class="dealer-cc-expiring-banner" v-if="showBanner">
    <v-container class="pr-12">
      <v-row dense>
        <v-col cols="12" class="pl-12">
          <div class="d-flex justify-space-between align-center">
            <div>
              <template v-if="dealerCCExpiring">
                {{ $t('dealer.chargify.cardExpiringExplainerText') }}
              </template>
              <template v-if="dealerIsPastDue && !dealerIsInvoiceNonExempt">
                {{ $t('dealer.chargify.pastDueText') }}
              </template>
              <template v-if="dealerIsPastDue && dealerIsInvoiceNonExempt">
                <i18n path="dealer.chargify.invoicePastDueText" tag="div">
                  <template v-slot:email>
                    <a href="mailto:billing@3xlogic.com">billing@3xlogic.com</a>
                  </template>
                </i18n>
              </template>
            </div>
            <v-btn
              @click="goToPayment"
              class="font-weight-bold"
              light
              v-if="isDealerAdmin && !dealerIsInvoiceNonExempt"
              >{{ $t('dealer.chargify.addPaymentMethod') }}</v-btn
            >
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { mapGetters, mapActions } from 'vuex'
export default defineComponent({
  name: 'DealerCCBanner',
  data() {
    return {
      showBanner: false,
    }
  },
  computed: {
    ...mapGetters('Security', [
      'dealerCCExpiring',
      'isDealerAdmin',
      'dealerIsBillable',
      'dealerIsPastDue',
      'dealerIsInvoiceNonExempt',
    ]),
    ...mapGetters('Environment', ['hasChargify']),
  },
  methods: {
    ...mapActions('Payment', ['goToPaymentTab']),
    goToPayment() {
      if (this.$route.name == 'Administration') {
        this.goToPaymentTab(true)
      } else {
        this.$router.push({ name: 'Administration', params: { tab: 3 } })
      }
    },
    showCCBanner() {
      if (
        this.hasChargify &&
        (this.dealerIsBillable || this.dealerIsInvoiceNonExempt) &&
        ((this.dealerCCExpiring && this.isDealerAdmin) || this.dealerIsPastDue)
      ) {
        this.showBanner = true
      } else {
        this.showBanner = false
      }
    },
  },
  mounted() {
    this.showCCBanner()
  },
  watch: {
    dealerCCExpiring() {
      this.showCCBanner()
    },
    dealerIsPastDue() {
      this.showCCBanner()
    },
  },
})
</script>

<style lang="scss">
.dealer-cc-expiring-banner {
  background-color: $color-secondary;
}
</style>
